import { useState, useEffect, Children, cloneElement } from "react";
import { createPortal } from "react-dom";

const Lightbox = ({ active, title, children, onCloseRequest }) => {
  const [isReady, setIsReady] = useState(null);
  const [isOpen, setIsOpen] = useState(null);

  useEffect(() => {
    setIsReady(true);
    setIsOpen(true);
  }, []);

  const handleContentAreaClick = (event) => {
    event.preventDefault();

    // Request lightbox close when
    // clicking lightbox content but not on content
    if (event.target === event.currentTarget) {
      onCloseRequest();
    }
  };

  const renderChildren = () => {
    // Clone each child and pass onCloseRequest props
    return Children.map(children, (child) => {
      return cloneElement(child, {
        onCloseRequest,
      });
    });
  };

  return (
    active &&
    isReady &&
    isOpen &&
    createPortal(
      <div
        className={`fixed top-0 left-0 flex flex-col items-center justify-center bg-white w-full h-full z-[3000] ${
          title ? "lightbox-container-with-title" : ""
        }`}
      >
        <div
          className="fixed top-20px right-20px cursor-pointer p-1.5 z-50"
          onClick={onCloseRequest}
        >
          <svg width="30" height="30">
            <g stroke="rgb(0, 0, 0)" strokeWidth="4">
              <line x1="5" y1="5" x2="25" y2="25"></line>
              <line x1="5" y1="25" x2="25" y2="5"></line>
            </g>
          </svg>
        </div>

        <div
          className="flex flex-grow  justify-center w-full overflow-y-auto"
          onClick={handleContentAreaClick}
        >
          {title && (
            <div className="absolute w-full bottom-0 left-0 bg-black bg-opacity-90 text-13px font-bold leading-normal text-center text-gray-text">
              {title}
            </div>
          )}
          {renderChildren()}
        </div>
        <style jsx global>
          {`
            html,
            body {
              overflow: hidden;
            }
          `}
        </style>
      </div>,
      document.body
    )
  );
};

// TODO: Find a way to replace the body style from jsx to tailwind

export default Lightbox;
